export default "__VITE_ASSET__CcwrlEEL__"